/* eslint-disable jsx-a11y/alt-text */
import { Tooltip } from '@mui/material'

export const ReactLogo = () => (
  <Tooltip title='React'>
    <img src='https://img.icons8.com/office/48/000000/react.png' />
  </Tooltip>
)

export const TypescriptLogo = () => (
  <Tooltip title='Typescript'>
    <img src='https://img.icons8.com/color/48/000000/typescript.png' />
  </Tooltip>
)

export const TerraformLogo = () => (
  <Tooltip title='Terraform'>
    <img src='https://img.icons8.com/fluency/48/000000/terraform.png' />
  </Tooltip>
)

export const NodeLogo = () => (
  <Tooltip title='Node.js'>
    <img src='https://img.icons8.com/color/48/000000/nodejs.png' />
  </Tooltip>
)

export const GithubLogo = () => (
  <Tooltip title='Github'>
    <img src='https://img.icons8.com/fluency/48/000000/github.png' />
  </Tooltip>
)

export const GithubLogo64 = () => (
  <Tooltip title='Github'>
    <img src='https://img.icons8.com/nolan/64/github.png' />
  </Tooltip>
)

export const GitlabLogo = () => (
  <Tooltip title='GitLab'>
    <img src='https://img.icons8.com/color/48/000000/gitlab.png' />
  </Tooltip>
)

export const JiraLogo = () => (
  <Tooltip title='Jira'>
    <img src='https://img.icons8.com/color/48/000000/jira.png' />
  </Tooltip>
)

export const PythonLogo = () => (
  <Tooltip title='Python'>
    <img src='https://img.icons8.com/color/48/000000/python--v1.png' />
  </Tooltip>
)

export const AWSLogo = () => (
  <Tooltip title='AWS'>
    <img src='https://img.icons8.com/color/48/000000/amazon-web-services.png' />
  </Tooltip>
)

export const AzureLogo = () => (
  <Tooltip title='Azure'>
    <img src='https://img.icons8.com/color/48/000000/azure-1.png' />
  </Tooltip>
)

export const PostgresLogo = () => (
  <Tooltip title='PostgreSQL'>
    <img src='https://img.icons8.com/color/48/000000/postgreesql.png' />
  </Tooltip>
)

export const MariaDbLogo = () => (
  <Tooltip title='MariaDB'>
    <img src='https://img.icons8.com/color/48/000000/maria-db.png' />
  </Tooltip>
)

export const UnityLogo = () => (
  <Tooltip title='Unity'>
    <img src='https://img.icons8.com/ios-filled/50/000000/unity.png' />
  </Tooltip>
)

export const AndroidLogo = () => (
  <Tooltip title='Android'>
    <img src='https://img.icons8.com/color/48/000000/android-os.png' />
  </Tooltip>
)

export const CSharpLogo = () => (
  <Tooltip title='C#'>
    <img src='https://img.icons8.com/color/48/000000/c-sharp-logo.png' />
  </Tooltip>
)

export const PlayStoreLogo = () => (
  <Tooltip title='PlayStore'>
    <img src='https://img.icons8.com/color/48/000000/google-play.png' />
  </Tooltip>
)

export const MUILogo = () => (
  <Tooltip title='Material UI'>
    <img src='https://img.icons8.com/color/48/000000/material-ui.png' />
  </Tooltip>
)

export const InvestmentLogo = () => (
  <Tooltip title='Day Trading'>
    <img
      src='https://img.icons8.com/external-becris-flat-becris/64/000000/external-portfolio-business-management-becris-flat-becris.png'
      width='48px'
      height='48px'
    />
  </Tooltip>
)

export const SolanaLogo = () => (
  <Tooltip title='Solana'>
    <img
      src='https://cryptologos.cc/logos/solana-sol-logo.png'
      width='40px'
      height='40px'
    />
  </Tooltip>
)

export const BitcoinLogo = () => (
  <Tooltip title='Bitcoin'>
    <img
      src='https://img.icons8.com/stickers/100/000000/bitcoin.png'
      width='48px'
      height='48px'
    />
  </Tooltip>
)

export const EthereumLogo = () => (
  <Tooltip title='Ethereum'>
    <img
      src='https://img.icons8.com/fluency/48/000000/ethereum.png'
      width='48px'
      height='48px'
    />
  </Tooltip>
)

export const LinkedInLogo = () => (
  <Tooltip title='LinkedIn'>
    <img src='https://img.icons8.com/external-justicon-flat-justicon/64/000000/external-linkedin-social-media-justicon-flat-justicon.png' />
  </Tooltip>
)

export const DockerLogo = () => (
  <Tooltip title='Docker'>
    <img src='https://img.icons8.com/color/48/000000/docker.png' />
  </Tooltip>
)

export const CloudflareLogo = () => (
  <Tooltip title='Cloudflare'>
    <img src='https://img.icons8.com/color/48/000000/cloudflare.png' />
  </Tooltip>
)

export const WindowsLogo = () => (
  <Tooltip title='Windows'>
    <img src='https://img.icons8.com/fluency/48/000000/windows-10.png' />
  </Tooltip>
)

export const MacOSLogo = () => (
  <Tooltip title='Mac OSX'>
    <img src='https://img.icons8.com/color/48/000000/mac-os-logo.png' />
  </Tooltip>
)

export const LinuxLogo = () => (
  <Tooltip title='Linux'>
    <img src='https://img.icons8.com/color/48/000000/linux--v1.png' />
  </Tooltip>
)

export const HTMLLogo = () => (
  <Tooltip title='HTML'>
    <img src='https://img.icons8.com/color/48/000000/html-5--v1.png' />
  </Tooltip>
)

export const CSSLogo = () => (
  <Tooltip title='CSS'>
    <img src='https://img.icons8.com/color/48/000000/css3.png' />
  </Tooltip>
)

export const JavascriptLogo = () => (
  <Tooltip title='Javascript'>
    <img src='https://img.icons8.com/color/48/000000/javascript--v2.png' />
  </Tooltip>
)

export const ConfluenceLogo = () => (
  <Tooltip title='Confluence'>
    <img src='https://img.icons8.com/fluency/48/000000/confluence.png' />
  </Tooltip>
)

export const JavaLogo = () => (
  <Tooltip title='Java'>
    <img src='https://img.icons8.com/material-outlined/48/000000/java-coffee-cup-logo.png' />
  </Tooltip>
)

export const SolidityLogo = () => (
  <Tooltip title='Solidity'>
    <img
      src='https://img.icons8.com/ios-filled/50/000000/solidity.png'
      width='48px'
      height='48px'
    />
  </Tooltip>
)

export const MatlabLogo = () => (
  <Tooltip title='Matlab'>
    <img src='https://img.icons8.com/fluency/48/000000/matlab.png' />
  </Tooltip>
)

export const ElrondLogo = () => (
  <Tooltip title='Elrond'>
    <img
      src='https://assets.coingecko.com/coins/images/12335/large/elrond3_360.png?1626341589'
      width='32px'
      height='32px'
    />
  </Tooltip>
)

export const TwitterLogo = () => (
  <Tooltip title='mfbevan'>
    <img src='https://img.icons8.com/color/64/twitter--v1.png' />
  </Tooltip>
)
